import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import handleChangeEmail from '../../../../services/apollo/func/handle/handleChangeEmail';
import handleUpdateUser from '../../../../services/apollo/func/handle/handleUpdateUser';

export const getSchema = () => {
  const schema = yup.object().shape({
    currentEmail: yup.string().trim().required(''),
    newEmail: yup.string().trim().required(''),
  });
  return schema;
};

export const getForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    currentEmail: '',
    newEmail: '',
  },
  resolver: yupResolver(schema),
});

export const changeEmail = async (email) => {
  try {
    const changedEmail = await handleChangeEmail({ email });
    return changedEmail;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};

export const updateUser = async (payload) => {
  try {
    const input = {
      userId: payload.userId,
      email: payload.newEmail,
    };
    const updatedUser = await handleUpdateUser({ input });
    return updatedUser;
  } catch (err) {
    return {
      isSuccess: false,
      message: err.message,
    };
  }
};
